import { useEffect, useState } from "react";
import { api, imgSrc } from "../lib/api";
import { PageHero } from "../components/site/Layout";
import { OrderCTA } from "../components/site/OrderCTA";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../components/ui/dialog";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("All");
  const [view, setView] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data));
    api.get("/meta").then((r) => setCats(r.data.categories));
  }, []);

  const shown = active === "All" ? items : items.filter((i) => i.category === active);

  return (
    <>
      <PageHero eyebrow="Gallery" title="Our latest" script="creations" testid="gallery-hero">
        A peek at the pieces we've stitched for our amazing customers.
      </PageHero>
      <section className="mx-auto max-w-7xl px-6 py-14">
        <div className="-mx-6 flex gap-2 overflow-x-auto px-6 pb-2" data-testid="gallery-filters">
          {["All", ...cats].map((c) => (
            <button key={c} onClick={() => setActive(c)} data-testid={`gallery-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`shrink-0 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors duration-200 ${active === c ? "bg-[#FF1F8E] text-white" : "gold-trim bg-white hover:bg-[#FFF4F8]"}`}>
              {c}
            </button>
          ))}
        </div>
        <div className="mt-10 columns-1 gap-5 sm:columns-2 lg:columns-3" data-testid="gallery-grid">
          {shown.map((it) => (
            <button key={it.id} onClick={() => setView(it)} className="group mb-5 block w-full break-inside-avoid overflow-hidden rounded-2xl bg-[#FFF4F8] text-left" data-testid={`gallery-item-${it.id}`}>
              <img src={imgSrc(it)} alt={it.caption} loading="lazy" className="w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
              <div className="p-4">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D4A537]">{it.category}</p>
                {it.caption && <p className="mt-1 font-medium">{it.caption}</p>}
              </div>
            </button>
          ))}
        </div>
        {shown.length === 0 && <p className="py-16 text-center text-[#0E0B0D]/60" data-testid="gallery-empty">New pieces in this category are coming soon.</p>}
      </section>
      <Dialog open={!!view} onOpenChange={(o) => !o && setView(null)}>
        <DialogContent className="max-w-3xl p-3" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{view?.caption || "Gallery photo"}</DialogTitle>
          <DialogDescription className="sr-only">{view?.category}</DialogDescription>
          {view && <img src={imgSrc(view)} alt={view.caption} className="max-h-[80vh] w-full rounded-lg object-contain" />}
          {view?.caption && <p className="px-2 pb-1 font-medium">{view.caption}</p>}
        </DialogContent>
      </Dialog>
      <OrderCTA />
    </>
  );
}
